export default "__VITE_ASSET__3e3301cc__"